<template>
  <e-charts
    ref="line"
    :options="option"
    theme="theme-color"
    auto-resize
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markLine'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/line'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      option: {
        tooltip: this.optionData.tooltip || {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        legend: this.optionData.legend || {
          show: true,
          left: 0,
        },
        grid: this.optionData.grid,
        xAxis: this.optionData.xAxis,
        yAxis: this.optionData.yAxis,
        series: this.optionData.series,
      },
    }
  },
  activated() {
    // Trigger resize when component is reactivated (keep-alive)
    this.$nextTick(() => {
      setTimeout(() => {
        this.resize()
      }, 100)
    })
  },
  methods: {
    resize() {
      if (this.$refs.line) {
        this.$refs.line.resize()
      }
    },
    getChartInstance() {
      // vue-echarts exposes the chart instance via the chart property or $el.__chartInstance
      if (this.$refs.line) {
        return this.$refs.line.chart || this.$refs.line
      }
      return null
    },
  },
}
</script>
